const tableButtonStyles = {
  height: '30px',
  borderRadius: '5px',
  padding: '0px 10px',
  margin: '2px auto',
  border: '1px solid black',
}

export const Button = ({
  children,
  className = '',
  noMargin,
  noPadding,
  disabled = false,
  type = 'button',
  onClick,
  style,
  tableStyles,
}: {
  children: React.ReactNode
  className?: string
  disabled?: boolean
  type?: 'button' | 'submit' | 'reset'
  onClick?: () => void
  noMargin?: boolean
  noPadding?: boolean
  style?: React.CSSProperties
  tableStyles?: boolean
}) => {
  const buttonStyle = tableStyles ? { ...tableButtonStyles, ...style } : style

  return (
    <button
      className={`border border-gray text-gray-10 uppercase ${className} ${
        noMargin ? '' : 'ml-2'
      } ${noPadding ? '' : 'px-4 py-2'}`}
      disabled={disabled}
      onClick={onClick}
      type={type}
      style={buttonStyle}
    >
      {children}
    </button>
  )
}
